import React  from 'react';

import {Col} from 'react-bootstrap';
import noPostsFound from '../../images/empty.svg';
import {Button} from '@material-ui/core';

export default function NoData(props) {
    return(
        <Col md='12'  className="text-center pt-3 pb-5" >
            <div className="pt-3 pb-1">
                <img src={props.img ? props.img : noPostsFound} alt="No Posts" className="img-fluid" />
            </div>
            <div className="w-100 text-center">
                <h2 className="text-dark">No Message selected</h2>
                <p className="text-grey">Please select your message to start chatting</p>
            </div>
    </Col>
    )
}